import React from "react";

import AriaAppLogo from "../../icons/aria-app-logo";

import lbl from "../../data/Labels.json";

const ClientLogo = ({ onLogoClick }) => {
  return (
    <div className="client-logo-area">
      <i
        role="button"
        tabIndex={0}
        aria-label={lbl.SystemTitle}
        onClick={onLogoClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onLogoClick?.();
          }
        }}
      >
        <AriaAppLogo />
      </i>
      <p>{lbl.SystemTitle}</p>
    </div>
  );
};

export default ClientLogo;
